import { render, staticRenderFns } from "./SetList.vue?vue&type=template&id=523e431a&scoped=true&"
import script from "./SetList.vue?vue&type=script&lang=js&"
export * from "./SetList.vue?vue&type=script&lang=js&"
import style0 from "./SetList.vue?vue&type=style&index=0&id=523e431a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523e431a",
  null
  
)

export default component.exports